import { render, staticRenderFns } from "./LogisticsBookingOrderManagement.vue?vue&type=template&id=6943d9e8&scoped=true"
import script from "./LogisticsBookingOrderManagement.vue?vue&type=script&lang=ts"
export * from "./LogisticsBookingOrderManagement.vue?vue&type=script&lang=ts"
import style0 from "./LogisticsBookingOrderManagement.vue?vue&type=style&index=0&id=6943d9e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6943d9e8",
  null
  
)

export default component.exports